import { render, staticRenderFns } from "./StudentWish.vue?vue&type=template&id=dea3d79c&"
import script from "./StudentWish.vue?vue&type=script&lang=js&"
export * from "./StudentWish.vue?vue&type=script&lang=js&"
import style0 from "./StudentWish.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports